import { z } from "zod";

import { WidgetDtoSchema } from "./widgets";

export const UserInterfaceDtoSchema = z.object({
  id: z.string().uuid(),
  isEnabled: z.boolean().optional(),
  isArchived: z.boolean().default(false),
  widget: WidgetDtoSchema.optional(),
  widgetId: z.string(),
  variationId: z.string().uuid().optional(),
  desktopVariables: z.any().default({}),
  mobileVariables: z.any().default({}),
});

export type UserInterfaceDto = z.infer<typeof UserInterfaceDtoSchema>;

export const PartialUserInterfaceDtoSchema =
  UserInterfaceDtoSchema.partial().extend({
    id: z.string().uuid(),
    isEnabled: z.boolean().optional(),
    isArchived: z.boolean().default(false),
    variationId: z.string().uuid().optional(),
    desktopVariables: z.any().default({}),
    mobileVariables: z.any().default({}),
    widget: z.optional(WidgetDtoSchema),
  });

export type PartialUserInterfaceDto = z.infer<
  typeof PartialUserInterfaceDtoSchema
>;

export const OfferQuantityButtonSchema = z.object({
  id: z.string().uuid(),
  quantity: z.number().default(1),
  unitName: z.string().default("units"),
  extraMessage: z.string().nullish(),
  fullPriceMessage: z.string().nullish(),
});
export type OfferQuantityButtonType = z.infer<typeof OfferQuantityButtonSchema>;
